<template>
    <v-container>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back()">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <div class="mb-5">
        <material-card color="primary" :title="this.permission
          + ' Jenis Dokumen Organisasi'" class="card-wrapper">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <!-- {{ imagePdfItems }} -->

                <!-- {{ chosenPemarafs }}
                {{ chosenPenandatangans }} -->
                <!-- {{ chosenJenisTtds }}
                <br/>
                <br/>
                {{ chosenPemarafs }}
                <br/>
                {{ chosenPenandatangans }} -->
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Organisasi<span style="color: red">*</span></p>
                  <v-autocomplete
                    :items="filteredOrganisasi"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    :disabled="currentPeran==='A05' || ubah || detail"
                    :rules="organisasiRules"
                    placeholder="Pilih Organisasi"
                    clearable
                    dense
                    outlined
                    :readonly="currentPeran==='A05'"
                    v-model="formData.id_organisasi"
                    @input="validateAllAndResetDuplicateValid"
                    @blur="validateAllAndResetDuplicateValid()"
                    @keydown.enter.prevent
                    @change="loadImages(true)"
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Jenis Dokumen<span style="color: red">*</span></p>
                  <v-autocomplete
                    :items="filteredJenisDokumens"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    :rules="jenisDokumenRules"
                    :disabled="ubah || detail"
                    placeholder="Pilih Jenis Dokumen"
                    clearable
                    dense
                    outlined
                    v-on:change="setWorkflowPersetujuan"
                    v-model="formData.id_jenis_dokumen"
                    @input="validateAllAndResetDuplicateValid"
                    @blur="validateAllAndResetDuplicateValid()"
                    @keydown.enter.prevent
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Tingkat Kerahasiaan<span style="color: red">*</span></p>
                  <v-select
                    :items="tingkatKerahasiaans"
                    :rules="tingkatKerahasiaanRules"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    :disabled="detail"
                    placeholder="Tingkat Kerahasiaan"
                    v-model="formData.id_kerahasiaan"
                    @blur="validateAll()"
                    outlined
                    >
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">{{ (!this.detail ? 'Upload ' : '') + 'File Template' }}</p>
                  <v-file-input v-if="!this.detail" accept=".pdf" v-model="file" :hint="(this.tambah || this.detail || (this.ubah && this.formData.file_dokumen === '')) ? 'File pdf' : 
                  'Jika anda mengisi file baru pada File Template, maka posisi tandatangan pada halaman Preview akan di-reset untuk diposisikan kembali. Jika dalam proses ubah anda perlu mengambil posisi tandatangan yang sudah tersimpan, silahkan tekan tombol Muat Ulang'" persistent-hint="true" @change="loadSourcePdf()" outlined></v-file-input>
                  <a v-if="(this.ubah || this.detail) && this.formData.file_dokumen !== ''" @click="downloadFile()"> {{ namaFile }}</a> &nbsp;
                  <v-btn v-if="this.ubah && this.formData.file_dokumen !== '' && this.imagePdfItemsTmp.length <= 0" :loading="loadingHapus" style="color: red" class="mr-4" @click="deleteFile()">Hapus File</v-btn>
                  <v-btn v-if="this.ubah && this.formData.file_dokumen !== ''" style="color: blue" class="mr-4" @click="dialogMuatUlang =  true">Muat Ulang</v-btn> 
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Workflow Persetujuan</p>
                  <v-text-field 
                    placeholder="Workflow Persetujuan" 
                    disabled
                    v-model="workflowPersetujuan"                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  label="Jenis Tanda Tangan"
                  :items="jenisTtds"
                  :item-text="item => item.Nama"
                  :item-value="item => item.Id"
                  :disabled="detail || !formData.id_organisasi"
                  no-data-text="Tidak ada data"
                  v-model="chosenIdJenisTtds"
                  @change="loadImages(true)"
                  multiple
                />
              </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card
                        elevation="4"
                    >
              <v-card-title style="background-color:#d3dadf">
                Daftar Pemaraf
              </v-card-title>
              <v-container>
                <v-row v-if="!detail">
                    <v-col
                        cols="12"
                        sm="6"
                    >
                    <!-- <p class="label font-weight-bold mb-1">Nama</p> -->
                    <v-autocomplete
                      :items="pemarafs"
                      :item-text="item => item.nama_lengkap + ' - ' + item.jabatan + ' - ' + item.nik + ' - ' + item.nama_organisasi"
                      :item-value="item => item"
                      placeholder="Pilih Pemaraf"
                      clearable
                      dense
                      outlined
                      no-data-text="Tidak ada data"
                      v-model="selectedPemaraf"
                      :loading="loading"
                      @keydown.enter.prevent
                    >
                    </v-autocomplete>
                    <h6 style="color: red;">{{ pemarafError }}</h6>
                    </v-col>

                    <v-col
                    cols="12"
                    sm="6"
                    md="2"
                    >
                    <v-btn color="primary" dark @click="addPemaraf">Tambah</v-btn>
                    </v-col>
                </v-row>
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">
                            No
                        </th>
                        <th class="text-left">
                            Nama
                        </th>
                        <th class="text-left">
                            NIK
                        </th>
                        <th class="text-left">
                            Nama Organisasi (PAU/Fakultas/Sekolah)
                        </th>
                        <th>Perlu Visual Paraf</th>
                        <th v-if="!detail" class="text-left">
                            Aksi
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(pemaraf, key) in chosenPemarafs"
                        >
                        <td>{{ key + 1 }}</td>
                        <td>{{ pemaraf.Pengguna.nama_lengkap + ' - ' + pemaraf.Pengguna.jabatan }}</td>
                        <td>{{ pemaraf.Pengguna.nik }}</td>
                        <td v-if="pemaraf.Pengguna.organisasi">{{ pemaraf.Pengguna.organisasi }}</td>
                        <td v-else>{{ pemaraf.Pengguna.Organisasi.Nama }}</td>
                        <td><v-checkbox v-model= pemaraf.flag_visual :disabled="detail" @change="loadImages(true)"/></td>
                        <td  v-if="!detail">
                          <v-btn
                            color="red"
                            dark
                            class="mr-4"
                            @click="hapusPemaraf(pemaraf.urutan_hirarki)"
                          >
                            Hapus
                          </v-btn>
                        </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
              </v-container>
              </v-card>
                </v-col>

                <v-col cols="12" class="mt-5">
                    <v-card
                        elevation="4"
                    >
                        <v-card-title style="background-color:#d3dadf">
                            Daftar Penandatangan
                        </v-card-title>
                        <v-container>
                            <v-row v-if="!detail">
                                <v-col
                                    cols="12"
                                    sm="6"
                                >
                                <!-- <p class="label font-weight-bold mb-1">Nama</p> -->
                                <v-autocomplete
                                :items="penandatangans"
                                :item-text="item => item.nama_lengkap + ' - ' + item.jabatan + ' - ' + item.nik + ' - ' + item.nama_organisasi"
                                :item-value="item => item"
                                placeholder="Pilih Penandatangan"
                                clearable
                                dense
                                outlined
                                no-data-text="Tidak ada data"
                                v-model="selectedPenandaTangan"
                                :loading="loading"
                                @keydown.enter.prevent
                                >
                                </v-autocomplete>
                                <h6 style="color: red;">{{ penandatanganError }}</h6>
                                </v-col>

                                <v-col
                                cols="12"
                                sm="6"
                                md="2"
                                >
                                <v-btn color="primary" dark @click="addPenandatangan">Tambah</v-btn>
                                </v-col>
                            </v-row>
                            <v-simple-table>
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th class="text-left">
                                        No
                                    </th>
                                    <th class="text-left">
                                        Nama
                                    </th>
                                    <th class="text-left">
                                        NIK
                                    </th>
                                    <th class="text-left">
                                        Organisasi
                                    </th>
                                    <th>Perlu Visual Tandatangan</th>
                                    <th v-if="!detail" class="text-left">
                                        Aksi
                                    </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(penandatangan, index) in chosenPenandatangans" :key="penandatangan.id_pengguna"
                                    >
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ penandatangan.Pengguna.nama_lengkap + ' - ' + penandatangan.Pengguna.jabatan }}</td>
                                    <td>{{ penandatangan.Pengguna.nik }}</td>
                                    <td v-if="penandatangan.Pengguna.organisasi">{{ penandatangan.Pengguna.organisasi }}</td>
                                    <td v-else>{{ penandatangan.Pengguna.Organisasi.Nama }}</td>
                                    <td><v-checkbox v-model=penandatangan.flag_visual :disabled="detail" @change="loadImages(true)"/></td>
                                    <td  v-if="!detail">
                                    <v-btn
                                        color="red"
                                        dark
                                        class="mr-4"
                                        @click="hapusPenandatangan(penandatangan.index)"
                                    >
                                        Hapus
                                    </v-btn>
                                    </td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-container>
                    </v-card>
                </v-col>
                <v-col sm="12" md="4" offset-md="8" class="mt-5">
                    <v-checkbox
                        v-if="tambah || ubah"
                        label="Saya telah mengkonfirmasi posisi tanda tangan dan kesesuaian dokumen di atas"
                        @click="cek()"
                        v-model="isChecked"
                        :disabled="chosenPenandatangans.length === 0"
                    ></v-checkbox>
                </v-col>
            </v-row>            
            <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                        color="green"
                        dark
                        @click="openModal()"
                      >
                        Preview
                  </v-btn>
                  <v-dialog
                    v-model="dialog"
                    persistent
                    style="z-index:99999;">
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Preview Dokumen
                      </v-card-title>

                      <v-card-text>
                        <DragAndDrop ref="dragdrop" :source="sourcePdf" :ttd-items="imagePdfItems" :dialog="dialog" :permission="permission">
                        </DragAndDrop>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="dialog = false"
                        >
                          Tutup
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>&nbsp;
                  <v-tooltip v-model="show" top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">
                            <v-btn v-on="on" :disabled="!isChecked" v-if="tambah || ubah" color="primary" dark @click="submit()">Simpan</v-btn>
                        </span>
                    </template>
                    <span>Harap beri tanda ceklis pada kotak yang disediakan di atas sebelum menyimpan</span>
                  </v-tooltip>
                  <v-btn v-if="detail && currentPeran === 'A01' " color="primary" dark @click="ubahRedirect()">Ubah</v-btn>
                  <v-dialog
                    v-model="dialogMuatUlang"
                    width="1000">
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Muat Ulang?
                      </v-card-title>

                      <v-card-text>
                        <br/>
                        <p>
                        Tombol ini akan memuat ulang posisi tandatangan yang tersimpan di database dan menghapus semua perubahan yang sudah diisi di halaman Ubah.
                        </p>  
                    </v-card-text>
                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-btn
                          color="primary" dark
                          text
                          @click="ubahRedirect()"
                        >
                          Muat Ulang
                        </v-btn>
                        &nbsp;
                        <!-- <v-spacer></v-spacer> -->
                        <v-btn
                          color="gray" text
                          @click="dialogMuatUlang = false"
                        >
                          Tutup
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
            </v-row>
          </v-form>
        </material-card>
      </div>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
            {{ snackbarText }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-container>
    
  </template>
  
  <script>
  import pdf from 'vue-pdf'
  import { apiServer } from "../../setup-axios";
  import DragAndDrop from "./DragAndDrop.vue";
  import { stampPath } from '../../config/env'
  import { qrPlaceHolder } from '../../config/env'
  import { bsreDisclaimer } from '../../config/env'
  import { parafPath } from '../../config/env'
  import { signPath } from '../../config/env'
  
  export default {
    name: 'TambahJenisDokumenOrganisasi',
    components: {
        DragAndDrop
    },
    data: () => ({
        loading: false,
        loadingHapus: false,
        showSimpan: false,
        isChecked: false,
        pemarafError: "",
        penandatanganError: "",
        jenisDokumens: [],
        snackbar: false,
        snackbarText: "",
        snackbarColor: "",
        workflowPersetujuan: "",
        duplicateValid: true,
        organisasis: [],
        jenisTtds:[],
        chosenPenandatangans: [],
        selectedPenandaTangan: null,
        penandatangans: [],
        chosenPemarafs: [],
        selectedPemaraf: null,
        pemarafs: [],
        tingkatKerahasiaans: [],
        path: window.location.pathname,
        tambah: window.location.pathname.startsWith("/jenis-dokumen-organisasi/tambah"),
        ubah: window.location.pathname.startsWith("/jenis-dokumen-organisasi/ubah"),
        detail: window.location.pathname.startsWith("/jenis-dokumen-organisasi/detail"),
        permission: '',
        deleteIndexPenandatangan: -1,
        deleteIndexPemaraf: -1,
        namaFile: "",
        formData: {
            id: null,
            id_jenis_dokumen: null,
            id_organisasi: null,
            id_kerahasiaan: null,
            ttd_jenis_dokumen: [],
        },
        imagePdfItemsTmp: [],
        dialogMuatUlang: false,
        chosenJenisTtds: [],
        chosenIdJenisTtds: [],
        file: null,
        sourcePdf: null,
        imagePdfItems: [],
        dialog: false,
        currentPeran: "",
        organisasiFileStamp : ""
    }),
    computed: {
        filteredJenisDokumens() {
            return this.jenisDokumens.filter(item => item.status);
        },
        filteredOrganisasi() {
            return this.organisasis.filter(item => item.status);
        },
        jenisDokumenRules() {
            return [v => {
                    if (!v) {
                        return 'Jenis Dokumen Harus Diisi';
                    }
                    return this.duplicateValid;
                }
            ];
        },
        organisasiRules() {
            return [v => {
                    if (!v) {
                        return 'Organisasi Harus Diisi';
                    }
                    return this.duplicateValid;
                }
            ];
        },
        tingkatKerahasiaanRules() {
            return [v => {
                    if (!v) {
                        return 'Tingkat Kerahasiaan Harus Diisi';
                    }
                    return true;
                }
            ];
        }
    },
    async created() {
        this.currentPeran = localStorage.getItem("currentPeran")
        this.permission = this.tambah ? 'Tambah' : (this.ubah ? 'Ubah' : 'Detail')
        this.getJenisDokumen();
        this.getOrganisasi();
        this.getTingkatKerahasiaan();
        this.getPenandatangan();
        this.getJenisTtd()
        if (this.ubah || this.detail) {
            await this.getJenisDokumenOrganisasi(this.$route.params.id);
            // await this.loadOrganisasiFileStamp()
            // await this.getJenisTtdJenisDokumenOrganisasi(this.$route.params.id)
        }
    },
    watch: {
      chosenPenandatangans(newVal) {
        if (newVal.length === 0) {
          this.isChecked = false;
        }
      }
    },
    methods: {
        getJenisDokumen() {
            apiServer
                .get("/jenis_dokumen/all")
                .then(response => {
                this.jenisDokumens = response.data.data;
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        },
        setWorkflowPersetujuan(id_jenis_dokumen) {
            this.workflowPersetujuan = "";
            this.jenisDokumens.forEach((item, index) => {
                if (item.id == id_jenis_dokumen) {
                    this.workflowPersetujuan = item.alur_persetujuan;
                }
            });
        },
        getOrganisasi() {
            apiServer
                .get("/organisasi/all/filtered")
                .then(response => {
                console.log('filtered org', response.data.data)
                this.organisasis = response.data.data;
                if (this.currentPeran === 'A05') {
                    this.formData.id_organisasi = JSON.parse(localStorage.getItem("user")).pengguna.Organisasi.Id
                    console.log("Pengguna peran A05, idOrganisasi: " + this.formData.id_organisasi)
                    console.log(JSON.parse(localStorage.getItem("user")).pengguna.Organisasi)
                }
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        },
        getTingkatKerahasiaan() {
            this.isLoading = true;
            apiServer
                .get("/jenis_dokumen_organisasi/tingkat_kerahasiaan")
                .then(response => {
                this.tingkatKerahasiaans = response.data.data;
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
                this.isLoading = false;
            });
        },
        getJenisTtd() {
            apiServer
                .get("/arsip/jenis_ttd")
                .then(response => {
                    // console.log(response.data.data)
                    this.jenisTtds = response.data.data;
                    this.jenisTtds.forEach((item, index) => {
                        this.chosenJenisTtds.push({
                            id_jenis_ttd : item.Id,
                            flag_visual: false,
                        })
                    })

                })
                .catch(error => {
                    console.log("There was an error:", error.response.data.message); // Logs out the error
                });
        },
        getPenandatangan() {
            this.isLoading = true;
            apiServer
                // .get("/jenis_dokumen_organisasi/pengguna")
                .get("/arsip/dropdown_pemaraf_ttd")
                .then(response => {
                this.penandatangans = response.data.data;
                this.pemarafs = response.data.data
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
                this.isLoading = false;
            });
        },
        cek() {
            console.log("jenis: " + JSON.stringify(this.chosenJenisTtds))
        },
        addPemaraf() {
            // console.log("adding paraf: " + JSON.stringify(this.selectedPemaraf))
            if(!this.selectedPemaraf) {
                this.pemarafError = "Pilih pemaraf untuk melakukan Tambah"
            } else if(this.workflowPersetujuan === "") {
                this.pemarafError = "Isi Jenis Dokumen per Organisasi terlebih dahulu untuk menentukan jumlah pemaraf yang dapat diisi"
            } else if (this.selectedPemaraf.file_paraf == '') {
                this.pemarafError = "Pemaraf belum memiliki file paraf"
            } else {
                this.pemarafError = ""
                let parafAdd = {
                    id_jenis_dokumen_organisasi: this.$route.params.id,
                    id_pengguna	:	this.selectedPemaraf.id,
                    flag_visual:false,
                    tipe_ttd: 1,
                    urutan_hirarki	:	this.chosenPemarafs.length + 1,
                    koordinat: "",
                    halaman: null,
                    Pengguna : {
                        id	:	this.selectedPemaraf.id,
                        username: this.selectedPemaraf.username,
                        nama_lengkap :	this.selectedPemaraf.nama_lengkap,
                        file_paraf : this.selectedPemaraf.file_paraf,
                        jabatan	:	this.selectedPemaraf.jabatan,
                        nik : this.selectedPemaraf.nik,
                        organisasi : this.selectedPemaraf.nama_organisasi
                    },
                }
                this.chosenPemarafs.push(parafAdd)
                
            }
        },
        hapusPemaraf(i) {
            this.deleteIndexPemaraf = -1;
            this.chosenPemarafs.forEach((item, index) => {
                if ((index + 1) == i) {
                    this.deleteIndexPemaraf = index;
                }
            });
            if (this.deleteIndexPemaraf >= 0) {
                this.chosenPemarafs.splice(this.deleteIndexPemaraf, 1);
            }
        },
        addPenandatangan() {
            console.log("adding ttd: " + JSON.stringify(this.selectedPenandaTangan))
            if (!this.selectedPenandaTangan) {
                this.penandatanganError = "Pilih penandatangan untuk melakukan Tambah";
            }
            else if (this.workflowPersetujuan === "") {
                this.penandatanganError = "Isi Jenis Dokumen terlebih dahulu untuk menentukan jumlah penandatangan yang dapat diisi";
            } else if (this.selectedPenandaTangan.file_ttd == '') {
                this.penandatanganError = "Penandatangan belum memiliki file tanda tangan"
            } else if (this.workflowPersetujuan === "Langsung" && this.chosenPenandatangans.length > 0) {
                this.penandatanganError = "Workflow Persetujuan Langsung hanya bisa memilih 1 penandatangan";
            }
            else {
                this.penandatanganError = "";
                // this.selectedPenandaTangan.urutan = this.chosenPenandatangans.length + 1;
                // this.selectedPenandaTangan.tipe_ttd = 2;
                // this.selectedPenandaTangan.flag_visual = false;
                let ttdAdd = {
                    id_jenis_dokumen_organisasi: this.$route.params.id,
                    id_pengguna	:	this.selectedPenandaTangan.id,
                    urutan_hirarki	:	this.chosenPenandatangans.length + 1,
                    flag_visual:false,
                    tipe_ttd: 2,
                    urutan	:	this.chosenPenandatangans.length + 1,
                    koordinat: "",
                    halaman: null,
                    Pengguna : {
                        id:	this.selectedPenandaTangan.id,
                        username: this.selectedPenandaTangan.username,
                        nama_lengkap :	this.selectedPenandaTangan.nama_lengkap,
                        file_ttd : this.selectedPenandaTangan.file_ttd,
                        jabatan	:	this.selectedPenandaTangan.jabatan,
                        nik : this.selectedPenandaTangan.nik,
                        organisasi : this.selectedPenandaTangan.nama_organisasi
                    },
                }
                this.chosenPenandatangans.push(ttdAdd)
            }
        },
        hapusPenandatangan(i) {
          this.chosenPenandatangans.splice(i, 1);
        },
        validateAllAndResetDuplicateValid() {
            this.duplicateValid = true;
            this.$refs.form.validate();
        },
        validateAll() {
            this.$refs.form.validate();
        },
        async duplicateValidCheck() {
            this.isLoading = true;
            if (this.formData.id_organisasi && this.formData.id_jenis_dokumen) {
                return await apiServer
                    .get("/jenis_dokumen_organisasi/all", {
                    params: {
                        idOrganisasi: this.formData.id_organisasi,
                        idJenisDokumen: this.formData.id_jenis_dokumen
                    }
                })
                    .then(response => {
                    console.log(response);
                    if (response.data.total > 0) {
                        return "Kombinasi Organisasi dan Jenis Dokumen sudah ada";
                    }
                    else {
                        return true;
                    }
                })
                    .catch(error => {
                    console.log("There was an error:", error.response.data.message); // Logs out the error
                    this.isLoading = false;
                    return "Error pada pengecekan data duplikat";
                });
            }
            else {
                return true;
            }
        },
        setupFormDataBeforeSubmit() {
            if (this.tambah) {
                this.formData.id = 0;
            }
            this.formData.ttd_jenis_dokumen = [];

            //stamp, qr, deskripsi qr
            this.chosenJenisTtds.forEach((item, index) => {
                // check if chosenJenisTtds are selected
                var imagePdf = this.findElementById(item.id, this.imagePdfItems)
                if (item.flag_visual) {
                    delete imagePdf.koordinat.base64Src
                    this.formData.ttd_jenis_dokumen.push({
                        id_jenis_ttd: item.id_jenis_ttd,
                        flag_visual: true,
                        koordinat: JSON.stringify(imagePdf.koordinat),
                        halaman: imagePdf.page
                    });
                }
            });
            
            //list pemaraf
            this.chosenPemarafs.forEach((item, index) => {
                var pemarafSave = {
                    id_pengguna: item.Pengguna.id,
                    urutan_hirarki: (index + 1),
                    tipe_ttd: 1,
                    flag_visual: item.flag_visual,
                    id_jenis_ttd: null,
                }
                if(item.flag_visual) {
                    var imagePdf = this.findElementById(item.Pengguna.username.replace('.', '_') + '_paraf', this.imagePdfItems)
                    delete imagePdf.koordinat.base64Src
                    pemarafSave.koordinat = JSON.stringify(imagePdf.koordinat)
                    pemarafSave.halaman = imagePdf.page
                }
                this.formData.ttd_jenis_dokumen.push(pemarafSave);
            });
            //list penandatangan
            this.chosenPenandatangans.forEach((item, index) => {
                var ttdSave = {
                    id_pengguna: item.Pengguna.id,
                    urutan_hirarki: (index + 1),
                    tipe_ttd: 2,
                    flag_visual: item.flag_visual,
                    id_jenis_ttd: null,
                }
                if(item.flag_visual) {
                    var imagePdf = this.findElementById(item.Pengguna.username.replace('.', '_') + '_ttd', this.imagePdfItems)
                    delete imagePdf.koordinat.base64Src
                    ttdSave.koordinat = JSON.stringify(imagePdf.koordinat)
                    ttdSave.halaman = imagePdf.page
                }
                this.formData.ttd_jenis_dokumen.push(ttdSave);
            });
            this.formData.imagePdfItems = this.imagePdfItems
            
        },
        async submit() {

            this.pemarafError=""
            this.penandatanganError= ""
            if (this.tambah) {
                this.duplicateValid = await this.duplicateValidCheck().then(value => {
                    return value;
                });
            }
            
            var notValidTtdItemWithFile = this.sourcePdf && this.imagePdfItems.filter(item => (!item.page || item.page == 0)).length > 0
            var notValidTtdItemWithoutFile = !this.sourcePdf && this.imagePdfItems.length > 0
            var notValidPenandatanganLangsung = this.workflowPersetujuan == "Langsung" && this.chosenPenandatangans.length != 1;
            var notValidPenandatanganNonLangsung = this.chosenPenandatangans.length <= 1 && (this.workflowPersetujuan == 'Berjenjang' || this.workflowPersetujuan == 'Grup')

            var validPenandatangan = this.workflowPersetujuan == "Langsung" ? !notValidPenandatanganLangsung : !notValidPenandatanganNonLangsung
            var validTtdItem = this.sourcePdf ? !notValidTtdItemWithFile : !notValidTtdItemWithoutFile

            if (this.$refs.form.validate() && validPenandatangan && validTtdItem) {
                this.setupFormDataBeforeSubmit();
                var formdata = new FormData();
                formdata.append("JenisDokumenOrganisasi", JSON.stringify(this.formData));
                formdata.append("file", this.file);
                for (var pair of formdata.entries()) {console.log(pair[0]+ ': ' + pair[1]); }
                apiServer
                    .post("/jenis_dokumen_organisasi/save", formdata)
                    .then(response => {
                    console.log("inserted data: ", response.data.data);
                    localStorage.setItem('success', "Jenis Dokumen Organisasi berhasil " + (this.ubah ? 'diubah' : 'ditambah'));
                    this.$router.push('/jenis-dokumen-organisasi');
                    //this.$router.go('/jenis-dokumen-organisasi/detail/' + response.data.data.id);
                    //this.$forceUpdate();
                })
                    .catch(error => {
                    console.log("There was an error:", error.response.data.message); // Logs out the error
                });
                
                
            }
            if (notValidPenandatanganLangsung) {
                this.penandatanganError = "Workflow Persetujuan Langsung harus memilih 1 penandatangan";
            } else if(notValidPenandatanganNonLangsung) {
                this.penandatanganError = "Workflow Persetujuan Berjenjang atau Grup harus lebih dari 1 penandatangan"
            }
            if(notValidTtdItemWithFile) {
                this.showSnackbar('error','Masih ada Item Tandatangan yang belum memiliki posisi pada dokumen. Silahkan buka Preview Dokumen dan posisikan Item Tandatangan pada Dokumen')
            } else if(notValidTtdItemWithoutFile) {
                this.showSnackbar('error','Terdapat kebutuhan visual tandatangan berupa Item Tandatangan, namun tidak ada file yang di-upload. Silahkan hapus kebutuhan visual tandatangan, atau upload file template dan posisikan Item Tandatangan di menu Preview')
            }
        },
        async getJenisDokumenOrganisasi(id) {
            this.imagePdfItems = []
            await apiServer
                .get("/jenis_dokumen_organisasi/find?id=" + id)
                .then(async response => {
                this.chosenPemarafs = []
                this.chosenPenandatangans = []
                this.chosenIdJenisTtds = []
                this.formData = response.data.data;
                this.setWorkflowPersetujuan(this.formData.id_jenis_dokumen);
                this.formData.ttd_jenis_dokumen.forEach((item, index) => {
                    if (item.tipe_ttd == 1) {
                        this.chosenPemarafs.push(item)
                    }
                    if (item.tipe_ttd == 2) {
                        this.chosenPenandatangans.push(item)
                    }
                    if (item.id_jenis_ttd) {
                        this.chosenIdJenisTtds.push(item.id_jenis_ttd)
                    }
                });
                if(this.formData.file_dokumen) {
                    await this.loadSavedPdfFile()
                }
                //alert('begin')
                await this.loadImages(false)
                //alert('loaded images')

                await this.fillKoordinatTtdItems()
                //alert('filled koordinat')
                this.imagePdfItemsTmp = Object.assign([], this.imagePdfItems)
                //alert(this.formData.file_dokumen)
                if (this.formData.file_dokumen !== "") {
                    var splitPath = this.formData.file_dokumen.includes("\\") ? 
                        this.formData.file_dokumen.split("\\") : this.formData.file_dokumen.split("/");
                    //alert(JSON.stringify(splitPath) + ' ' + this.formData.file_dokumen)
                    if (splitPath.length < 3) {
                        this.formData.file_dokumen = "";
                    }
                    //alert(JSON.stringify(splitPath))
                    this.namaFile = splitPath[splitPath.length - 1];
                }
                if (localStorage.getItem("success") != null) {
                    this.showSnackbar("orange", localStorage.getItem("success"));
                    localStorage.removeItem("success");
                }
            })
                .catch(error => {
                console.log("There was an error:", error); // Logs out the error
            });
        },
        // drag and drop related
        async fillKoordinatTtdItems() {
            //loop ttd_jenis_dokumen
            await this.formData.ttd_jenis_dokumen.forEach((item, index) => {
                //alert(JSON.stringify(item))
                // if the item is of pemaraf
                // use username_paraf to find element in ttdItems
                // fill koordinat in ttdItems from ttd_jenis_dokumen
                if (item.tipe_ttd == 1 && item.flag_visual) {
                    var element = this.findElementById(item.Pengguna.username.replace('.', '_') + '_paraf', this.imagePdfItems)
                    element.koordinat = JSON.parse(item.koordinat)
                    element.page = item.halaman
                }
                // if the item is of penandatangan
                // use username_ttd to find element in ttdItems
                // fill koordinat in ttdItems from ttd_jenis_dokumen
                if (item.tipe_ttd == 2 && item.flag_visual) {
                    var element = this.findElementById(item.Pengguna.username.replace('.', '_') + '_ttd', this.imagePdfItems)
                    element.koordinat = JSON.parse(item.koordinat)
                    element.page = item.halaman
                }
                // if the item is of jenisTtd
                // find id used in ttdItems in chosenJenisTtds
                // use id to find element in ttdItems
                // fill koordinat in ttdItems from ttd_jenis_dokumen
                if (item.id_jenis_ttd) {
                    var chosenJenisTtd = null
                    for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
                        if(this.chosenJenisTtds[ii].id_jenis_ttd == item.id_jenis_ttd) {
                            chosenJenisTtd =  this.chosenJenisTtds[ii]
                        }
                    }
                    if(chosenJenisTtd) {
                        var element = this.findElementById(chosenJenisTtd.id, this.imagePdfItems)
                        element.koordinat = JSON.parse(item.koordinat)
                        element.page = item.halaman
                    }
                }
            });
        },
        // drag and drop related
        async fillChosenJenisTtds() {
            // reset all flag visual of jenis ttd into false
            for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
                this.chosenJenisTtds[ii].flag_visual = false
            }
            // set Id and file path of selected jenis ttd
            for(var jj = 0; jj < this.chosenIdJenisTtds.length; jj++) {
                let item = this.chosenIdJenisTtds[jj]
                let filePath = null
                let itemId = null
                if (item == 1) {
                    // find stamp file for selected organisasi
                    for(var kk = 0; kk < this.organisasis.length; kk++) {
                        var itemOrg = this.organisasis[kk] 
                        if (itemOrg.id == this.formData.id_organisasi) {
                            itemId = itemOrg.nama.trim().replaceAll(' ', '_') + '_organisasi'
                            filePath = await this.loadBase64File(stampPath + '/' + itemOrg.file_stamp)
                        }
                    };
                } else if(item == 2) {
                    itemId = "QRCode"
                    filePath = qrPlaceHolder
                } else {
                    itemId = "DeskripsiQR"
                    filePath = bsreDisclaimer
                }
                for(var ii = 0; ii < this.chosenJenisTtds.length; ii++) {
                    if(item + '' === this.chosenJenisTtds[ii].id_jenis_ttd + '') {
                        this.chosenJenisTtds[ii].flag_visual = true
                        this.chosenJenisTtds[ii].id = itemId
                        this.chosenJenisTtds[ii].filePath = filePath
                    }
                }
            }
            
            //console.log("jenis: " + JSON.stringify(this.chosenJenisTtds))
        },
        downloadFile() {
            const timestamp = new Date().getTime()
            apiServer
                .get("/files/get-by-filepath?target_path=" + this.formData.file_dokumen.replaceAll("\\", "/") + "&type=download&timestamp=" + timestamp, {
                responseType: 'blob'})
                .then(response => {
                console.log('file pdf', response.data)
                var link = document.createElement('a');
                var blob = new Blob([response.data])
                var urlCreator = window.URL;
                var source = urlCreator.createObjectURL(blob)
                link.href = source
                link.download = this.namaFile;
                document.body.appendChild(link)
                link.click();
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        },
        // drag and drop related
        async loadSavedPdfFile() {
            const timestamp = new Date().getTime()
            await apiServer
                .get("/files/get-by-filepath?target_path=" + this.formData.file_dokumen.replaceAll("\\", "/") + "&type=download&timestamp=" + timestamp, {
                headers: {
                    'Accept': 'application/pdf'
                },
                responseType: 'blob'
            })
                .then(response => {
                var blob = new Blob([response.data])
                const data = window.URL.createObjectURL(blob);
                this.sourcePdf = data
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        },
        back() {
            this.$router.push('/jenis-dokumen-organisasi');
        },
        ubahRedirect() {
            this.$router.push('/jenis-dokumen-organisasi/ubah/' + this.formData.id);
            this.$router.go('/jenis-dokumen-organisasi/ubah/' + this.formData.id);
        },
        showSnackbar(color, message) {
            this.snackbar = true;
            this.snackbarText = message;
            this.snackbarColor = color;
        },
        deleteFile() {
            this.loadingHapus = true;
            apiServer
                .get("/jenis_dokumen_organisasi/remove_dokumen?idJenisDokumenOrganisasi=" + this.formData.id)
                .then(response => {
                this.loadingHapus = false;
                localStorage.setItem('success', "File Template berhasil dihapus");
                this.$router.push('/jenis-dokumen-organisasi/ubah/' + this.formData.id);
                this.$router.go('/jenis-dokumen-organisasi/ubah/' + this.formData.id);
            })
                .catch(error => {
                console.log("There was an error:", error.response.data.message); // Logs out the error
            });
        },
        async openModal() {
            await this.loadImages(true)
            this.dialog = true
        },
        // drag and drop related
        findElementById(id, array) {
            for(var ii = 0; ii < array.length; ii++) {
                if((id + '') === (array[ii].id + '')) {
                    return array[ii]
                }
            }
            return null
        },
        // drag and drop related
        async loadImages(readExistingElement) {
            //alert('load')
            await this.fillChosenJenisTtds()
            var newImagePdfItems = []
            
            await this.chosenJenisTtds.forEach((item, index) => {
                if(item.flag_visual === true) {
                    var elementExists = this.findElementById(item.id, this.imagePdfItems)
                    if(elementExists && this.sourcePdf && readExistingElement) {
                        newImagePdfItems.push(elementExists)
                    } else  {
                        newImagePdfItems.push({path: item.filePath, 
                            id: item.id})
                    }
                }
            })

            for(var ii = 0; ii < this.chosenPemarafs.length; ii++) {
                var item = this.chosenPemarafs[ii]
                var idPdfItem = item.Pengguna.username.replace('.', '_') + "_paraf"
                if(item.flag_visual === true) {
                    var elementExists = this.findElementById(idPdfItem, this.imagePdfItems)
                    if(elementExists && this.sourcePdf && readExistingElement) {
                        newImagePdfItems.push(elementExists)
                    } else  {
                        var pathBase64 = await this.loadBase64File(parafPath + '/' + item.Pengguna.file_paraf)
                        newImagePdfItems.push({path: pathBase64, 
                            id: idPdfItem})
                    }
                }
            }

            for(var ii = 0; ii < this.chosenPenandatangans.length; ii++) {
                var item = this.chosenPenandatangans[ii]
                var idPdfItem = item.Pengguna.username.replace('.', '_') + "_ttd"
                if(item.flag_visual === true) {
                    var elementExists = this.findElementById(idPdfItem, this.imagePdfItems)
                    console.log(this.imagePdfItems)
                    if(elementExists && this.sourcePdf && readExistingElement) {
                        newImagePdfItems.push(elementExists)
                    } else  {
                        var pathBase64 = await this.loadBase64File(signPath + '/' + item.Pengguna.file_ttd)
                        newImagePdfItems.push({path: pathBase64, 
                            id: idPdfItem})
                    }
                }
            }

            this.imagePdfItems = newImagePdfItems
        },
        // drag and drop related
        async loadSourcePdf() {
          this.sourcePdf = null
          if(this.file) {
                this.sourcePdf = await this.loadBlobFile(this.file, 'application/pdf')   
                this.loadImages(false)           
          }
          else if(this.formData.file_dokumen && this.formData.file_dokumen !== '') {
            await this.loadSavedPdfFile()
            this.loadImages(false)           
          }
          
        },
        async loadBlobFile(file, type) {
          var blob = await new Blob([file])
          if(type) {
            blob = await new Blob([file], { type: type })
          }
          var urlCreator = window.URL;
          var source =  await urlCreator.createObjectURL(blob)
          return source
        },
        blobToData(blob) {
          return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.readAsDataURL(blob)
          })
        },
        async loadBase64File(path) {
            var base64 = ""
            await apiServer
                .get("/files/get-base64-image?target_path="+path)
                .then(response => {
                    base64 = response.data.data
                })
                .catch(error => {
                    console.log("There was an error:", error.response.data.message); // Logs out the error
                });
            return base64
        }
    },
    components: { DragAndDrop }
}
</script>
<style scoped>
.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: #cccccc !important;
}
</style>